import React                     from 'react';
import numeral                   from 'numeral';
import classnames                from 'classnames';
import { FontAwesomeIcon }       from '@fortawesome/react-fontawesome';

import PartImage                 from './PartImage';
import PartDatasheet             from './PartDatasheet';
import PartInfo                  from './PartInfo';
import PartStatus                from './PartStatus'
import PartActionSelector        from './PartActionSelector'
import PartMountingTypeSelector  from './PartMountingTypeSelector'
import PartMessage               from './PartMessage'

import PartEmptyOption           from './PartEmptyOption'
import PartOption                from './PartOption'

import {
  getPartStatus,
  getPartPurchaseStatus,
  rowPartClass,
  max_number_options,
  max_number_options_substitutes,
}from 'pu-utils/PartsUtilities';

const BomRow = (props) => {
  var offer = props.offer;
  var general_status = props.offer.status;
  var vendor_options = props.offer.vendor_options;

  var status = getPartStatus(general_status, props.selected_quantity);
  var purchase_status = getPartPurchaseStatus(offer.purchase_status, props.selected_quantity);
  var row_class = rowPartClass(status, purchase_status);
  var rowspan = max_number_options(vendor_options);
  
  if (status == "other"){
    offer = offer.other;
    vendor_options = offer.vendor_options;
    rowspan = max_number_options(vendor_options);
  }

  if (status == "substitute"){
    offer = offer.substitute;
    vendor_options = offer.vendor_options;
    rowspan = max_number_options_substitutes(vendor_options);
  }

  if (status == "no-stock" || status == "not-found" || status == "no-perfect-match"){
    rowspan = 1;
  }

  var options = [];
  var first_option_row = [];
   
  props.quantities.forEach((quantity, i) => {
    var actual_status = general_status[quantity];
    var opt;

    if (actual_status == "no-stock" || actual_status == "not-found" || actual_status == "no-perfect-match"){
      opt = <PartEmptyOption 
             key={"vendor-option-empty-" + props.offer_id + "-" + quantity}
             offer_id={props.offer_id}
             selected_quantity={props.selected_quantity} 
             quantity={quantity}
             others={props.offer.others}
             rowSpan={rowspan}
             onViewMore={props.onViewMore} 
             status={actual_status}/>
      first_option_row.push(opt);
    }else{
      if (actual_status != "substitute") {
        vendor_options[quantity].forEach(function (option, index) {
          opt = <PartOption
                    key={"vendor-option-" + props.offer_id + "-" + quantity + "-" + index}
                    offer_id={props.offer_id}
                    quantity={quantity}
                    selected_quantity={props.selected_quantity}
                    vendor={option.vendor}
                    vpn={option.vpn}
                    stock={option.stock}
                    required_qty={option.qty}
                    price={option.price} 
                    onViewMore = {props.onViewMore} 
                    rowSpan={props.rowspan} />
          
          if (index == 0){
            first_option_row.push(opt);
          }else{
            options.push(
              <tr 
               className={row_class + " other-options" + ((quantity == props.selected_quantity) ? " activate" : "")}>
                {opt}
              </tr>
            );
          }
        });
      }else{
        var cont = 0;
        vendor_options.forEach(function (option, index) {
          if (option.check !== undefined && option.check){
            opt = <PartOption
                    key={"vendor-option-" + props.offer_id + "-" + quantity + "-" + index}
                    offer_id={props.offer_id}
                    quantity={quantity}
                    selected_quantity={props.selected_quantity}
                    vendor={option.vendor}
                    vpn={option.vpn}
                    stock={option.stock}
                    required_qty={option.qty_selected}
                    price={option.price * option.qty_selected} 
                    onViewMore = {props.onViewMore} 
                    rowSpan={props.rowspan} />

            if (cont == 0){
              first_option_row.push(opt);
            }else{
              options.push(
                <tr 
                 className={row_class + " other-options" + ((quantity == props.selected_quantity) ? " activate" : "")}>
                  {opt}
                </tr>
              );
            }
            cont ++;
          }
        });
      }
    }
  })

  return(
    <React.Fragment>
      <tr className={row_class}>
        <td className="number"
         rowSpan={rowspan}>
          {props.cont}
        </td>
        <td className="image"
         rowSpan={rowspan}>
          <PartImage 
            images={offer.image} 
            selected_quantity={props.selected_quantity} />
        </td> 
        <td className="datasheet"
         rowSpan={rowspan}>
          <PartDatasheet 
            urls={offer.datasheet} 
            selected_quantity={props.selected_quantity}/>
        </td>
        <td className="status"
         rowSpan={rowspan}>
          <PartStatus 
            status={general_status} 
            selected_quantity={props.selected_quantity} />
        </td>
        <td className="mpn"
         rowSpan={rowspan}>
          <PartInfo 
           mpn={offer.mpn}
           manufacturer={offer.manufacturer}
           reference_designator={props.offer.reference_designator} />
          {(status == "substitute" || status == "other") 
            ? <div className="original-part">
                <span>Original Part: </span>
                {props.offer.mpn}
              </div>
            : null }
        </td>
        {first_option_row}
        <td className="action"
         rowSpan={rowspan}>
          <PartActionSelector 
           offer_id={props.offer_id} 
           status={general_status} 
           selected_quantity={props.selected_quantity} 
           purchase_status={props.offer.purchase_status}
           onChangePartAction = {props.onChangePartAction} />
        </td>
        <td className="mounting-type"
         rowSpan={rowspan}>
          {(offer.mounting_type == "" || offer.mounting_type === undefined) 
            ? <PartMountingTypeSelector 
               offer_id={props.offer_id} 
               mounting_type_entered={offer.mounting_type_entered}
               selected_quantity={props.selected_quantity} 
               onChangeMountingType = {props.onChangeMountingType} /> 
            : offer.mounting_type}
        </td>
      </tr>
      {(options.length > 0)
        ? options
        : null
      }
    </React.Fragment>
  ) 
}

export default BomRow;
